function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0 C0,0,34,0,34,0 C34,0,34,24,34,24 C34,24,0,24,0,24 C0,24,0,0,0,0 z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 1,
  stroke: "#d9d9d9",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeOpacity: 1,
  strokeWidth: 1,
  d: "M4,0.5 C2.067,0.5,0.5,2.067,0.5,4 C0.5,4,0.5,20,0.5,20 C0.5,21.933,2.067,23.5,4,23.5 C4,23.5,30,23.5,30,23.5 C31.933,23.5,33.5,21.933,33.5,20 C33.5,20,33.5,4,33.5,4 C33.5,2.067,31.933,0.5,30,0.5 C30,0.5,4,0.5,4,0.5 z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0 C0,0,34,0,34,0 C34,0,34,24,34,24 C34,24,0,24,0,24 C0,24,0,0,0,0 z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10.2455,3.91338 C10.2455,3.91338,79.6781,3.91338,79.6781,3.91338 C79.6781,3.91338,79.6781,20.7195,79.6781,20.7195 C79.6781,20.7195,10.2455,20.7195,10.2455,20.7195 C10.2455,20.7195,10.2455,3.91338,10.2455,3.91338 z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#009ee3",
  fillOpacity: 1,
  fillRule: "evenodd",
  opacity: 1,
  stroke: "none",
  d: "M16.3302,7.86927 C17.9103,7.86927,19.4903,7.86927,21.0704,7.86927 C23.6155,7.86927,24.5736,9.15772,24.4255,11.0506 C24.1808,14.1757,22.2916,15.9046,19.7856,15.9046 C19.7856,15.9046,18.5204,15.9046,18.5204,15.9046 C18.1766,15.9046,17.9453,16.1322,17.8524,16.7489 C17.8524,16.7489,17.3152,20.3341,17.3152,20.3341 C17.2797,20.5665,17.1574,20.7011,16.9738,20.7195 C16.9738,20.7195,13.9956,20.7195,13.9956,20.7195 C13.7154,20.7195,13.6163,20.5054,13.6897,20.0416 C14.295,16.2105,14.9002,12.3795,15.5055,8.54837 C15.5765,8.0883,15.8285,7.86927,16.3302,7.86927 z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#172c70",
  fillOpacity: 1,
  fillRule: "evenodd",
  opacity: 1,
  stroke: "none",
  d: "M13.3654,3.91338 C14.9471,3.91338,16.5288,3.91338,18.1105,3.91338 C19.4467,3.91338,21.0325,3.9562,22.0921,4.89226 C22.8006,5.51751,23.1726,6.5123,23.0869,7.58417 C22.7957,11.2072,20.6287,13.2372,17.7214,13.2372 C17.7214,13.2372,15.3819,13.2372,15.3819,13.2372 C14.983,13.2372,14.7199,13.5015,14.6074,14.2161 C14.3896,15.6028,14.1718,16.9896,13.954,18.3763 C13.9111,18.6455,13.7949,18.8046,13.5869,18.8241 C13.5869,18.8241,10.6588,18.8241,10.6588,18.8241 C10.3346,18.8241,10.2196,18.5794,10.304,18.0386 C10.304,18.0386,12.4086,4.70382,12.4086,4.70382 C12.493,4.16789,12.7879,3.91338,13.3654,3.91338 z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#172c70",
  fillOpacity: 1,
  fillRule: "evenodd",
  opacity: 1,
  stroke: "none",
  d: "M14.6759,13.7939 C14.952,12.0454,15.2281,10.2969,15.5043,8.54837 C15.5765,8.08829,15.8285,7.86805,16.3302,7.86805 C17.9103,7.86805,19.4903,7.86805,21.0704,7.86805 C21.8547,7.86805,22.4898,7.99041,22.9866,8.21677 C22.5106,11.4422,20.4244,13.2335,17.6933,13.2335 C17.6933,13.2335,15.3574,13.2335,15.3574,13.2335 C15.0442,13.2348,14.8142,13.3914,14.6759,13.7939 z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10.2455,3.91338 C10.2455,3.91338,79.6781,3.91338,79.6781,3.91338 C79.6781,3.91338,79.6781,20.7195,79.6781,20.7195 C79.6781,20.7195,10.2455,20.7195,10.2455,20.7195 C10.2455,20.7195,10.2455,3.91338,10.2455,3.91338 z"
});

var SvgPaypal = function SvgPaypal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34pt",
    height: "24pt",
    viewBox: "0 0 34 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaypal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Paypal.49776f19.svg";
export { ForwardRef as ReactComponent };